import React, { useState } from 'react';
import { BriefcaseIcon, CheckIcon, MapPinIcon, ClockIcon, XIcon, SendIcon, ChevronRightIcon, ListChecksIcon } from 'lucide-react';
type Job = {
  title: string;
  location: string;
  type: string;
  experience: string;
  description: string;
  responsibilities: string[];
  requirements: string[];
};
const CareersSection = () => {
  const [selectedJob, setSelectedJob] = useState<Job | null>(null);
  const [selectedPosition, setSelectedPosition] = useState('');
  const jobs: Job[] = [{
    title: 'Civil Engineer',
    location: 'Mumbai',
    type: 'Full-time',
    experience: '6+ months',
    description: 'Oversee construction activities at our Virar West project site and ensure quality standards are met.',
    responsibilities: ['Supervise day-to-day construction activities on site', 'Ensure work is carried out as per approved drawings and specifications', 'Coordinate with contractors, vendors, and site workers', 'Monitor material quality and maintain site records', 'Report progress and flag issues to the Project Manager', 'Ensure compliance with safety standards and regulations'],
    requirements: ['Diploma or B.E. in Civil Engineering', 'Minimum 6 months of site experience', 'Knowledge of construction materials and methods', 'Good communication and coordination skills', 'Willingness to work on-site in Virar West, Mumbai']
  }, {
    title: 'Project Manager',
    location: 'Mumbai',
    type: 'Full-time',
    experience: '1+ year',
    description: 'Lead and manage real estate development projects from inception to completion, coordinating with contractors and stakeholders.',
    responsibilities: ['Plan, execute, and oversee all phases of the project lifecycle', 'Coordinate with architects, engineers, contractors, and vendors', 'Track project timelines, budgets, and deliverables', 'Manage approvals, permits, and regulatory compliance', 'Communicate project status to senior management and stakeholders', 'Identify risks and implement mitigation strategies'],
    requirements: ['B.E./B.Tech in Civil Engineering or related field', 'Minimum 1 year of experience in real estate or construction project management', 'Strong leadership and problem-solving skills', 'Proficiency in project management tools', 'Knowledge of MahaRERA and local building regulations is a plus']
  }];
  const benefits = ['Competitive salary and bonuses', 'Health and life insurance', 'Professional development opportunities', 'Work-life balance', 'Modern office environment', 'Team building activities'];
  const openModal = (job: Job) => {
    setSelectedJob(job);
    setSelectedPosition(job.title);
  };
  const closeModal = () => {
    setSelectedJob(null);
    setSelectedPosition('');
  };
  return <section id="careers" className="py-20 bg-gray-50" data-id="element-154" data-mp="2hocerdsvacbd">
      <div className="container mx-auto px-4 lg:px-8" data-id="element-155" data-mp="2dmr5s3jgei6g">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-156" data-mp="28o7le7kideg7">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-157" data-mp="28mwdbvk15kja">
            Careers at Swastik Infra
          </h2>
          <div className="w-20 h-1 bg-blue-800 mx-auto mb-6" data-id="element-158" data-mp="23r7a9i8sxli8"></div>
          <p className="max-w-3xl mx-auto text-gray-600 text-lg" data-id="element-159" data-mp="1yqtf30sau61m">
            Join our team of professionals and build your career with one of
            India's leading real estate developers.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-160" data-mp="1pxy55trvzm5i">
          {/* Why Join Us */}
          <div className="lg:col-span-1" data-id="element-161" data-mp="1l0g7izjbktct">
            <div className="bg-white p-8 rounded-xl shadow-sm h-full" data-id="element-162" data-mp="1fz8xsuxm9k3i">
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-163" data-mp="1g1muf87y34d6">
                Why Join Us
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-164" data-mp="3b2oryjhsljj4">
                At Swastik Infra Developers, we believe in fostering talent and
                providing opportunities for growth. We are committed to creating
                an inclusive work environment where innovation thrives.
              </p>
              <div className="space-y-3" data-id="element-165" data-mp="36byojbsxfqr2">
                {benefits.map((benefit, index) => <div key={index} className="flex items-center gap-2" data-id="element-166" data-mp="2sc768yvdno79" data-mpi={index}>
                    <CheckIcon className="h-4 w-4 text-blue-800 flex-shrink-0" data-id="element-167" data-mp="2saw3n2do4mhq" />
                    <p className="text-gray-700 text-sm" data-id="element-168" data-mp="2xcv5g7trfbck">{benefit}</p>
                  </div>)}
              </div>
            </div>
          </div>

          {/* Current Openings */}
          <div className="lg:col-span-2 space-y-5" data-id="element-169" data-mp="2ndmfdq20mgvh">
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-170" data-mp="gmwffsz0vvlr">
              Current Openings
            </h3>
            {jobs.map((job, index) => <div key={index} className="bg-white rounded-xl shadow-sm p-6 border border-gray-100" data-id="element-171" data-mp="ll7po4t8c84i" data-mpi={index}>
                <div className="flex flex-wrap justify-between items-start gap-3 mb-3" data-id="element-172" data-mp="214yvgle75upg">
                  <h4 className="text-xl font-bold text-gray-900" data-id="element-173" data-mp="2ftl98io6eeek">
                    {job.title}
                  </h4>
                  <span className="inline-flex items-center gap-1.5 bg-green-50 text-green-700 text-xs font-semibold px-3 py-1 rounded-full border border-green-200" data-id="element-174" data-mp="2b2lcpeiyxycl">
                    <span className="w-1.5 h-1.5 rounded-full bg-green-500 inline-block" data-id="element-175" data-mp="2ow470od3u0ty"></span>
                    Hiring Now
                  </span>
                </div>

                <div className="flex flex-wrap gap-4 text-sm text-gray-500 mb-4" data-id="element-176" data-mp="2yro3bbvkz1j8">
                  <div className="flex items-center gap-1" data-id="element-177" data-mp="2tunwuzutjwrl">
                    <MapPinIcon className="h-4 w-4 text-blue-800" data-id="element-178" data-mp="14e6g5pz386oq" />
                    {job.location}
                  </div>
                  <div className="flex items-center gap-1" data-id="element-179" data-mp="zgd78p6egykr">
                    <BriefcaseIcon className="h-4 w-4 text-blue-800" data-id="element-180" data-mp="2zhkxljy976ad" />
                    {job.type}
                  </div>
                  <div className="flex items-center gap-1" data-id="element-181" data-mp="34fw5vq8wh8qh">
                    <ClockIcon className="h-4 w-4 text-blue-800" data-id="element-182" data-mp="34iimsghol0ld" />
                    {job.experience} experience
                  </div>
                </div>

                <p className="text-gray-600 text-sm mb-5" data-id="element-183" data-mp="3di5do8csao06">{job.description}</p>

                <button onClick={() => openModal(job)} className="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-800 hover:bg-blue-900 text-white text-sm font-medium rounded-lg transition-all" data-id="element-184" data-mp="3ih8jvw4i309q">
                  View Details & Apply
                  <ChevronRightIcon className="h-4 w-4" data-id="element-185" data-mp="2zelkym6rmc" />
                </button>
              </div>)}
          </div>
        </div>
      </div>

      {/* Job Detail Modal */}
      {selectedJob && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={e => {
      if (e.target === e.currentTarget) closeModal();
    }} data-id="element-186" data-mp="a1owhdqigc2l">
          <div className="bg-white rounded-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto shadow-2xl" data-id="element-187" data-mp="f4670roowm6t">
            {/* Modal Header */}
            <div className="sticky top-0 bg-white z-10 flex items-start justify-between px-6 py-5 border-b border-gray-100" data-id="element-188" data-mp="652mrkdse0qq">
              <div data-id="element-189" data-mp="12u0gcz9svsmb">
                <h2 className="text-xl font-bold text-gray-900" data-id="element-190" data-mp="12uk1spynsz53">
                  {selectedJob.title}
                </h2>
                <div className="flex flex-wrap gap-3 mt-2" data-id="element-191" data-mp="xy1w9nvi8wrp">
                  <span className="inline-flex items-center gap-1 text-xs text-gray-500" data-id="element-192" data-mp="t3xr9a5suyt9">
                    <MapPinIcon className="h-3.5 w-3.5 text-blue-800" data-id="element-193" data-mp="p2lywwvjjzhd" />
                    {selectedJob.location}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs text-gray-500" data-id="element-194" data-mp="1lnnvucfshe08">
                    <BriefcaseIcon className="h-3.5 w-3.5 text-blue-800" data-id="element-195" data-mp="1gtjq1wi9fc0q" />
                    {selectedJob.type}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs text-gray-500" data-id="element-196" data-mp="259brse1owui4">
                    <ClockIcon className="h-3.5 w-3.5 text-blue-800" data-id="element-197" data-mp="1qkpesizjceu2" />
                    {selectedJob.experience} experience
                  </span>
                </div>
              </div>
              <button onClick={closeModal} className="p-2 rounded-full hover:bg-gray-100 transition-colors flex-shrink-0" data-id="element-198" data-mp="1vhfuh57fh8ey">
                <XIcon className="h-5 w-5 text-gray-500" data-id="element-199" data-mp="2o7od0y5vluu2" />
              </button>
            </div>

            <div className="px-6 py-6 space-y-6" data-id="element-200" data-mp="29axawh4ti50r">
              {/* Description */}
              <div data-id="element-201" data-mp="2e8yqut6y5o80">
                <p className="text-gray-600 leading-relaxed" data-id="element-202" data-mp="2e8fd7oobxlzs">
                  {selectedJob.description}
                </p>
              </div>

              {/* Responsibilities */}
              <div data-id="element-203" data-mp="12wo7tei096gr">
                <h4 className="text-base font-bold text-gray-900 mb-3 flex items-center gap-2" data-id="element-204" data-mp="12t0f2hkdwo33">
                  <ListChecksIcon className="h-4 w-4 text-blue-800" data-id="element-205" data-mp="3h4yvdlzslbl7" />
                  Key Responsibilities
                </h4>
                <ul className="space-y-2" data-id="element-206" data-mp="3q3aihe1g9r8w">
                  {selectedJob.responsibilities.map((item, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-gray-600" data-id="element-207" data-mp="3m1pbuafie975" data-mpi={idx}>
                      <ChevronRightIcon className="h-4 w-4 text-blue-800 flex-shrink-0 mt-0.5" data-id="element-208" data-mp="2yaa1pvhhqnlc" />
                      {item}
                    </li>)}
                </ul>
              </div>

              {/* Requirements */}
              <div data-id="element-209" data-mp="32dpxyqpnelxi">
                <h4 className="text-base font-bold text-gray-900 mb-3 flex items-center gap-2" data-id="element-210" data-mp="32d6irhrdubn6">
                  <CheckIcon className="h-4 w-4 text-blue-800" data-id="element-211" data-mp="2en2ow23zxq9d" />
                  Requirements
                </h4>
                <ul className="space-y-2" data-id="element-212" data-mp="2amjvw4qdae5l">
                  {selectedJob.requirements.map((item, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-gray-600" data-id="element-213" data-mp="2zosx5blxn8bl" data-mpi={idx}>
                      <CheckIcon className="h-4 w-4 text-green-600 flex-shrink-0 mt-0.5" data-id="element-214" data-mp="2qp5w4qx484j2" />
                      {item}
                    </li>)}
                </ul>
              </div>

              {/* Divider */}
              <div className="border-t border-gray-100 pt-6" data-id="element-215" data-mp="2gtcdcpsszesu">
                <h4 className="text-base font-bold text-gray-900 mb-5" data-id="element-216" data-mp="2c09pmyapizkk">
                  Apply for this Position
                </h4>
                <form className="space-y-4" data-id="element-217" data-mp="272hqbj7qgb6c">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-218" data-mp="23165dqzt0e4h">
                    <div data-id="element-219" data-mp="1y1jsxjrsv1wq">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-220" data-mp="1y232od7aqjzo">
                        Full Name
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Your full name" data-id="element-221" data-mp="1t4jn99yv4165" />
                    </div>
                    <div data-id="element-222" data-mp="igrcgztqauul">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-223" data-mp="mkp8h1nrbpjf">
                        Email
                      </label>
                      <input type="email" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="you@email.com" data-id="element-224" data-mp="3m15gaq1sgggt" />
                    </div>
                    <div data-id="element-225" data-mp="3nfptmq9ag38">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-226" data-mp="3392smuqqbzx2">
                        Phone
                      </label>
                      <input type="tel" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="+91 98765 43210" data-id="element-227" data-mp="378v5hjn5os88" />
                    </div>
                    <div data-id="element-228" data-mp="o4y2sct8ko22">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-229" data-mp="j6o1dkgx4r80">
                        Position
                      </label>
                      <input type="text" value={selectedPosition} readOnly className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm bg-gray-50 text-gray-600" data-id="element-230" data-mp="3rn962p2ioy5b" />
                    </div>
                    <div data-id="element-231" data-mp="evbw0125o51">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-232" data-mp="1fwx3fchbof11">
                        Years of Experience
                      </label>
                      <input type="number" min="0" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="e.g. 2" data-id="element-233" data-mp="1bus9sdqvjiee" />
                    </div>
                    <div data-id="element-234" data-mp="1efrqc314osl0">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-235" data-mp="1eeyfoqz1tixl">
                        Upload Resume
                      </label>
                      <input type="file" accept=".pdf,.doc,.docx" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-236" data-mp="227f6pr0rkl91" />
                    </div>
                  </div>
                  <div data-id="element-237" data-mp="2l3oksebo1bt1">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-238" data-mp="2l35a9iochpp1">
                      Cover Letter
                    </label>
                    <textarea rows={3} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Tell us why you're a great fit..." data-id="element-239" data-mp="2pwrcsi0sod74" />
                  </div>
                  <div className="flex gap-3 pt-2" data-id="element-240" data-mp="n9ugipiq38wy">
                    <button type="submit" className="flex-1 inline-flex items-center justify-center gap-2 py-3 bg-blue-800 hover:bg-blue-900 text-white font-medium rounded-lg transition-all text-sm" data-id="element-241" data-mp="nb5icjsly6lf">
                      <SendIcon className="h-4 w-4" data-id="element-242" data-mp="1b688qw728i40" />
                      Submit Application
                    </button>
                    <button type="button" onClick={closeModal} className="px-5 py-3 border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium rounded-lg transition-all text-sm" data-id="element-243" data-mp="167nj1qpfpgtt">
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>}
    </section>;
};
export default CareersSection;